(function () {
    angular.module('pages.master', [
        //'foundation',
        //'mm.foundation',
        'app',
        'components.anchor',
        'components.sticky',
        'components.carousel',                
        'components.loader',
        'components.modalSlider',
        'components.navigation',
        'components.pagination',
        'components.query',
        'components.relatedContent',
        'components.externalForm',
        'components.tiles',
        'pages.home',
        'pages.scrolledContent',
        'pages.tabbedContent',
        'utility',
        'services.global',
        'fullPage.js',
        'ui.router',
        'caseStudyResource',
        'component.caseStudyTile',
        'serviceResource',
    ])
        .config(config)
        .run(run)
        .controller('modalSetController', modalSetController);
    
    run.$inject = ['$rootScope', 'global', '$location', '$http', '$window', '$timeout', '$state', '$transitions', 'modalSliderService'];
    function run($rootScope, global, $location, $http, $window, $timeout, $state, $transitions, modalSliderService) {
        $rootScope.ready = true;
        $rootScope.toggleSearch = function () {
            $rootScope.searchOpen = !$rootScope.searchOpen;
        }
        const body = angular.element('body');
        const mobileToggle = angular.element('#mobile-toggle');
        const menuIcon = angular.element('button.menu-icon');
        const isDarkHeader = angular.element(body).hasClass('dark-header');

        body.css('border-right-width', $window.outerWidth - angular.element('body').width());
        $rootScope.toggleDropdown = function () {
            $rootScope.dropdownOpen = !$rootScope.dropdownOpen;
            const header = angular.element('.header');
            const dropdown = header.find('.dropdown');
            const multiNav = header.find('.multi-nav');
            const mainNav = multiNav.find('ul:first-child > li');
            const secondNav = multiNav.find('ul.top-links');
            const leftCol = dropdown.find('.menu-left-col');

            if ($rootScope.dropdownOpen) {
                var timeline = new TimelineLite()
                    //.set(dropdown, { height: 'auto', 'max-height': 'calc(100vh - ' + header.height() + 'px)' })
                    .set(body, { 'overflow-y': 'hidden' })
                    .set(body, { className: '+=dark-header' })
                    .set(dropdown, { className: '+=active' })
                    .to(dropdown, 0.25, { y: 0, ease: Power4.easeInOut }, '-=0.2')
                    .staggerTo(mainNav, 0.5, { opacity: 1, x: 0, startAt: { x: -200 }, ease: Power4.easeInOut }, 0.05, '-=0.2')
                    .to(secondNav, 0.25, { opacity: 1, y: 0, startAt: { y: -100 }, ease: Power1.easeInOut }, '-=0.3')
                    .to(leftCol, 0.5, { opacity: 1, x: 0, startAt: { x: 200 }, ease: Back.easeIn }, '-=0.75')
                    .set(dropdown, { 'overflow-y': 'auto' });
                    //.set(dropdown, { 'overflow-y': 'auto' });
            }
            else {
                var timeline = new TimelineLite()
                    //.set(dropdown, { 'overflow-y': 'hidden' })
                    .set(dropdown, { className: '-=active' })
                    .set(dropdown, { 'overflow-y': 'hidden' })
                    .to(dropdown, .3, { y: '-120%', ease: Power2.easeInOut })
                    .set(dropdown, { clearProps: 'all' })
                    .set(body, { 'overflow-y': 'auto' })
                    .set(mainNav, { opacity: 0 })
                    .set(secondNav, { opacity: 0 })
                    .set(leftCol, { opacity: 0 })
                if (!isDarkHeader) {
                    timeline.set(body, { className: '-=dark-header' });
                }
            }
        }

        $timeout(function () {
            var datepickers = $('.datepickerfield');
            if (datepickers.datepicker) {
                datepickers.datepicker({
                    dateFormat: 'mm/dd/y',
                    onClose: function (date, instance) {
                        instance.input.valid();
                    }
                });
            }
        });

        //Forces components that bind to "params" to update when it's modified.
        $rootScope.params = {};
        $rootScope.$watch('params', function (newVal) {
            if (newVal) {
                $rootScope.params = angular.copy($rootScope.params);
            }
        }, true);

        $rootScope.revealIfSticking = function (sticking, element) {
            if ($window.wow) {
                $window.wow.sync();
                if (sticking) {
                    $timeout(function () {
                        var targets = element.find('.wow').get();
                        for (var i = 0; i < targets.length; i++) {
                            $window.wow.show(targets[i]);
                        }
                    })
                }
            }
        }
    }

    config.$inject = ['$locationProvider', '$stateProvider', '$transitionsProvider'];
    function config($locationProvider, $stateProvider, $transitionsProvider) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
            rewriteLinks: false
        });
    }

    function modalSetController() {

    }
})();

